import {
    Component,
    ElementRef,
    Input,
    Output,
    OnInit,
    ViewChild,
    EventEmitter,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { fuseAnimations } from "@fuse/animations";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { SucursalesService } from "app/main/apps/shared/services/rest/sucursales.service";
import { fromEvent, Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";

import { SucursalPersonaDTO } from "app/main/apps/shared/interfaces/sucursal-persona.interface";
import { OnDestroy } from "@angular/core";

@Component({
    selector: "app-sucursales",
    templateUrl: "./sucursales.component.html",
    styleUrls: ["./sucursales.component.scss"],
    animations: fuseAnimations,
})
export class SucursalesComponent implements OnInit, OnDestroy {
    @Input() sucursales: SucursalPersonaDTO[];
    @Input() esSupervisor: boolean;
    @Input() esRepresentante: boolean;
    @Input() esEncargado: boolean;

    @Output() buscarMas: EventEmitter<any> = new EventEmitter();
    @Output() verEncargadosSucursal: EventEmitter<number> = new EventEmitter();
    @Output() borrarSucursal: EventEmitter<number> = new EventEmitter();
    @Output() editarSucursal: EventEmitter<number> = new EventEmitter();

    dataSource: MatTableDataSource<any>;
    displayedColumns = [
        "nombre",
        "direccion",
        "telefono",
        "acciones",
        
    ];

    @ViewChild(MatPaginator, { static: true })
    paginator: MatPaginator;

    @ViewChild(MatSort, { static: true })
    sort: MatSort;

    @ViewChild("filter", { static: true })
    filter: ElementRef;

    resultsLength = 0;
    private subscripciones: Subscription;
    private _unsubscribeAll: Subject<any>;
    constructor() {
        this.subscripciones = new Subscription();
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {

        if (this.esRepresentante || this.esSupervisor){
            this.displayedColumns.push('borrar');
        }

        this.dataSource = new MatTableDataSource(this.sucursales);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.subscripciones.add(
            this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0))
        );

        fromEvent(this.filter.nativeElement, "keyup")
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(150),
                distinctUntilChanged()
            )
            .subscribe(() => {
                if (!this.dataSource) {
                    return;
                }

                this.dataSource.filter = this.filter.nativeElement.value;
            });
    }

    verEncargados(idSucursal: number) {
        this.verEncargadosSucursal.emit(idSucursal);
    }

    borrar(idSucursal: number): void {
        this.borrarSucursal.emit(idSucursal);
    }

    editar(sucursal) {
        this.editarSucursal.emit(sucursal);
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
